(() => {
  /* Launch build 2026-10-07 (Claude Code): hold this page's below-the-fold images (img[data-ps-defer], snippets/
     cf-ps-defer.liquid) and the display web font until the hero photograph has loaded, so nothing of ours competes
     with the LCP image on a slow phone link. Boxes keep their size (no layout shift); text shows in a system serif
     until the font is ready (font-display: swap), then switches in one step. */
  const release = () => {
    document.querySelectorAll('img[data-ps-defer]').forEach(img => {
      if (img.dataset.sizes) img.sizes = img.dataset.sizes;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      if (img.dataset.src) img.src = img.dataset.src;
      img.removeAttribute('data-ps-defer');
    });
    const root = document.documentElement;
    if (root.classList.contains('ps-fonts') || root.dataset.psFontsPending) return;
    const family = document.querySelector('[data-ps-font]')?.dataset.psFont;
    const on = () => root.classList.add('ps-fonts');
    if (family && document.fonts && document.fonts.load) {
      root.dataset.psFontsPending = 'true';
      Promise.all([document.fonts.load(`500 1em "${family}"`), document.fonts.load(`italic 500 1em "${family}"`)]).then(on, on);
      setTimeout(on, 4000);
    } else on();
  };
  const hero = document.querySelector('.cf-ps-stage__img');
  if (!hero || hero.complete) release();
  else {
    hero.addEventListener('load', release, { once: true });
    hero.addEventListener('error', release, { once: true });
    setTimeout(release, 8000);
  }
  document.addEventListener('shopify:section:load', release);

  if (!customElements.get('pro-shield-surface')) {
    class ProShieldSurface extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.stage = this.querySelector('[data-ps-water-stage]');
        if (!this.stage) return;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.sync = () => {
          this.stage.dataset.psVisible = String(this.visible && !document.hidden);
          if (this.motion.matches || document.hidden || !this.visible) {
            this.classList.remove('is-rolling');
            return;
          }
          this.classList.add('is-rolling');
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= .2;
          this.sync();
        }, { threshold: [0, .2] });
        this.observer.observe(this.stage);
        this.motion.addEventListener('change', this.sync);
        document.addEventListener('visibilitychange', this.sync);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.motion?.removeEventListener('change', this.sync);
        document.removeEventListener('visibilitychange', this.sync);
        this.classList.remove('is-rolling');
        if (this.stage) delete this.stage.dataset.psVisible;
        this.ready = false;
      }
    }
    customElements.define('pro-shield-surface', ProShieldSurface);
  }
  if (!customElements.get('pro-shield-mechanism')) {
    class ProShieldMechanism extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.stage = this.querySelector('[data-ps-mechanism-stage]');
        if (!this.stage) return;
        this.observer = new IntersectionObserver(entries => {
          this.stage.dataset.psVisible = String(entries[0].isIntersecting);
        });
        this.observer.observe(this.stage);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        if (this.stage) delete this.stage.dataset.psVisible;
        this.ready = false;
      }
    }
    customElements.define('pro-shield-mechanism', ProShieldMechanism);
  }
  const tabKeys = (tabs, event) => {
    const i = tabs.indexOf(event.target.closest('[role="tab"]'));
    if (i < 0) return null;
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') return tabs[(i + 1) % tabs.length];
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') return tabs[(i - 1 + tabs.length) % tabs.length];
    if (event.key === 'Home') return tabs[0];
    if (event.key === 'End') return tabs[tabs.length - 1];
    return null;
  };
  if (!customElements.get('pro-shield-picker')) {
    class ProShieldPicker extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[data-ps-tab]')];
        this.onClick = event => { const tab = event.target.closest('[data-ps-tab]'); if (tab && this.contains(tab)) this.select(tab); };
        this.onKey = event => { const next = tabKeys(this.tabs, event); if (next) { event.preventDefault(); this.select(next, true); } };
        this.onBlock = event => { const tab = event.target.closest?.('[data-ps-tab]'); if (tab) this.select(tab); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('shopify:block:select', this.onBlock);
        this.dataset.psReady = 'true';
      }
      select(tab, focus = false) {
        this.tabs.forEach(item => {
          const on = item === tab;
          item.setAttribute('aria-selected', String(on));
          item.tabIndex = on ? 0 : -1;
        });
        this.querySelectorAll('[data-ps-panel]').forEach(panel => panel.toggleAttribute('data-ps-inactive', panel.id !== tab.getAttribute('aria-controls')));
        if (focus) tab.focus();
      }
      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('shopify:block:select', this.onBlock);
        this.ready = false;
      }
    }
    customElements.define('pro-shield-picker', ProShieldPicker);
  }
  if (!customElements.get('pro-shield-lab')) {
    class ProShieldLab extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = [...this.querySelectorAll('[data-ps-clip-tab]')];
        this.onClick = event => { const tab = event.target.closest('[data-ps-clip-tab]'); if (tab && this.contains(tab)) this.select(tab, false, true); };
        this.onKey = event => { const next = tabKeys(this.tabs, event); if (next) { event.preventDefault(); this.select(next, true, false); } };
        this.onBlock = event => { const tab = event.target.closest?.('[data-ps-clip-tab]'); if (tab) this.select(tab); };
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('shopify:block:select', this.onBlock);
        this.observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) { this.pauseAll(); return; }
          const video = this.querySelector('[data-ps-clip]:not([hidden]) video');
          if (video && video.preload === 'none') video.preload = 'metadata';
        }, { rootMargin: '200px 0px' });
        this.observer.observe(this);
      }
      pauseAll() { this.querySelectorAll('video').forEach(video => { if (!video.paused) video.pause(); }); }
      select(tab, focus = false, play = false) {
        this.pauseAll();
        this.tabs.forEach(item => {
          const on = item === tab;
          item.setAttribute('aria-selected', String(on));
          item.tabIndex = on ? 0 : -1;
        });
        let shown = null;
        this.querySelectorAll('[data-ps-clip]').forEach(clip => {
          const on = clip.id === tab.getAttribute('aria-controls');
          clip.hidden = !on;
          if (on) shown = clip;
        });
        if (focus) tab.focus();
        const video = shown?.querySelector('video');
        if (video && play && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          video.muted = true;
          video.play()?.catch?.(() => {});
        }
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('shopify:block:select', this.onBlock);
        this.pauseAll();
        this.ready = false;
      }
    }
    customElements.define('pro-shield-lab', ProShieldLab);
  }
})();
